<template>
    <UICard
        class="login-content"
        :header="{
            logo: 'fingerprint',
            title: $t('login.signin'),
        }"
        :footer="{
            title: $t('login.noAccount'),
            label: $t('login.createAccount'),
            to: '/registration',
        }"
    >
        <LoginForm />
    </UICard>
</template>

<script>
import UICard from "@/components/ui/card/card.vue";
import LoginForm from "@/components/shared/login/form/form.vue";

export default {
    name: "LoginContent",
    components: {
        UICard,
        LoginForm,
    },
};
</script>
